import { ProductCardType } from '@/constants'
import type { BlockCMS, Product } from '@/types'
import { v4 as uuidv4 } from 'uuid'
import ProductCard from '../ProductCard'

interface ModuleProductListFullType {
  data: BlockCMS
  order: number
}
const ModuleProductListFull = ({ data, order }: ModuleProductListFullType) => {
  return (
    <section
      id={data._id}
      className={`${data?.type} ${data?.hideBot ? '' : 'pb-[20px]'} ${
        'order-[' + (order + 1) + ']'
      } scroll-mt-[160px]`}
    >
      <div
        className='products grid grid-cols-4 rounded-lg px-2 pt-4'
        style={{
          backgroundColor: data?.color,
          backgroundImage: `url(${data?.image})`,
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top left',
        }}
      >
        {data &&
          data?.data.map((item: Product) => (
            <ProductCard
              product={item}
              layout={4}
              type={ProductCardType.PRODUCT_LIST_FULL_CMS}
              className='mb-[20px] px-2.5'
              key={uuidv4()}
            />
          ))}
      </div>
    </section>
  )
}

export default ModuleProductListFull
